import BuyerPricingPlans from "./BuyerPricingPlans";

const BuyerLandingPricing = () => {
  return (
    <section className="py-16 px-4 bg-gray-900/30">
      <div className="container mx-auto max-w-2xl text-center">
        <h2 className="text-3xl font-bold mb-8">Simple, Transparent Pricing</h2>
        <BuyerPricingPlans billingPeriod="monthly" />
      </div>
    </section>
  );
};

export default BuyerLandingPricing;
